import storage from '@/services/storageApi';

/* ============
 * Getters for the auth module
 * ============
 *
 * The getters that are available on the
 * auth module.
 */

export default {
  getProjectMaster: state => state.projectMaster || storage.getSessionData('pm'),
  getAuctions: (state) => {
    const master = state.projectMaster;
    const auctions = {};
    if (master) {
      const ids = Object.keys(master).filter(id =>
        (master[id].auction_status === 'LIVE-AUCTION' || master[id].auction_status === 'UPCOMING-AUCTION'),
      );
      ids.forEach((id) => {
        auctions[id] = master[id];
      });
    }
    return auctions;
  },
  getScheduled: (state) => {
    const master = state.projectMaster;
    const scheduled = {};
    if (master) {
      const ids = Object.keys(master).filter(id =>
        (master[id].auction_status === 'VALUE-LISTING' || master[id].auction_status === 'NEW' || master[id].auction_status === 'CLOSED'),
      );
      ids.forEach((id) => {
        scheduled[id] = master[id];
      });
    }
    return scheduled;
  },
  getVerified: (state) => {
    const master = state.projectMaster;
    const verified = {};
    if (master) {
      const ids = Object.keys(master).filter(id =>
        (master[id].auction_status !== 'NOT-VERIFIED'),
      );
      ids.forEach((id) => {
        verified[id] = master[id];
      });
    }
    return verified;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/master/getters.js